import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const postOneTimePay = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/payment/payment/onetime`,
    param,
  );
  return data;
};

const PaymentApi = {
  postOneTimePay,
};

export default PaymentApi;
